export default "__VITE_ASSET__B8vd2CXB__"